import React, { useEffect, useState, useCallback } from 'react';
import { Row, Col, Layout, Menu, Modal } from 'antd';
import { useLocation, Outlet, useParams } from 'react-router-dom';
import './publicLayout.less';
import { handlers } from '../helpers/helpers';
import LogoNaranjo2023 from '../images/LogoNaranjo2023.svg';

const { Header, Content } = Layout;

const PublicLayout = ({ children }) => {
  const [userName, setUserName] = useState();
  const [testName, setTestName] = useState();
  const [timerOn, setTimerOn] = useState();
  const [initialTimeStamp, setInitialTimeStamp] = useState();
  const [psychologyRoute, setPsychologyRoute] = useState(false);
  const [patientLandingRoute, setPatientLandingRoute] = useState(false)
  const [withoutHeader, setWithoutHeader] = useState(false);
  const dateTime = new Date();
  const currentMilisecondsTime = Date.parse(dateTime);
  const location = useLocation();
  const { countryCode } = useParams();

  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false);

  const handleLogout = () => {
    setIsLogoutModalVisible(true);
  };

  const handleLogoutConfirm = () => {
    localStorage.clear();
    setIsLogoutModalVisible(false);
    window.location.href = `/mis-examenes/${countryCode || 'CL'}`;
  };

  const refreshInitialTimeStamp = () => {
    const getInitialTimeStamp = JSON.parse(localStorage.getItem("initialTimeStamp"));
    if (getInitialTimeStamp) {
      setInitialTimeStamp(getInitialTimeStamp);
      handlers.handleCurrentTimeStamp(currentMilisecondsTime);
    } else {
      setInitialTimeStamp();
    }
  };

  const refreshTestName = () => {
    const getUserData = JSON.parse(localStorage.getItem("userData"));
    if (getUserData && getUserData.currentTestName !== null) {
      setTestName(getUserData.currentTestName);
    } else {
      setTestName();
    }
  };

  const refreshTimer = () => {
    const getUserData = JSON.parse(localStorage.getItem("userData"));
    if (getUserData && getUserData.isTimerOn) {
      setTimerOn(getUserData.isTimerOn);

    } else {
      setTimerOn(false);
    }
  };

  const refreshUserName = () => {
    const getUserData = JSON.parse(localStorage.getItem("userData"));
    if (getUserData) {
      setUserName(getUserData.full_name);
    } else {
      setUserName();
    }
  };

  const checkPsychologyRoute = useCallback(() => {
    if (
      location.pathname.includes('/examenes/psicologia')
    ) {
      setPsychologyRoute(true);
    } else {
      setPsychologyRoute(false);
    }
  }, [location]);

  const checkPatientLandingRoute = useCallback(() => {
    if (location.pathname.includes('/mis-examenes')) {
      setPatientLandingRoute(true)
      if (location.pathname.includes('estado') || location.pathname.includes('encuesta')) {
        setWithoutHeader(false);
      } else {
        setWithoutHeader(true);
      }
    } else {
      setPatientLandingRoute(false);
    }
  }, [location])

  const confirmRefreshPage = event => {
    event.preventDefault();

    const message = '¿Estás seguro que deseas abandonar el Test de Psicología?';

    return event.returnValue = message;
  };

  useEffect(() => {
    refreshTimer();
    refreshTestName();
    refreshUserName();
    refreshInitialTimeStamp();
    checkPsychologyRoute();
    checkPatientLandingRoute();

    if (psychologyRoute && patientLandingRoute) {
      window.addEventListener('beforeunload', confirmRefreshPage);

      return () => {
        window.removeEventListener('beforeunload', confirmRefreshPage);
      }
    }
  }, [userName, testName, timerOn, initialTimeStamp, checkPsychologyRoute, patientLandingRoute]);

  return (
    <Layout className="public-layout">
      {
        !withoutHeader &&
        <Header className="header">
          <div className={!psychologyRoute ? "logo no-psychology" : "logo"}>
            <img src={LogoNaranjo2023} alt="Logo CMT salud" height={43} />
          </div>
          {
            (psychologyRoute || patientLandingRoute) &&
            <Menu theme="light" mode="horizontal" className={testName && 'menu-space-between'}>
              {
                testName && timerOn &&
                <Menu.Item key="2" className="item-text-test-wrapper">
                  <Row>
                    <Col>
                      <p className="text-test-name mr-15">{testName}</p>
                    </Col>
                  </Row>
                </Menu.Item>
              }
              {
                psychologyRoute &&
                <Menu.Item key="1" style={{ padding: 0 }}>
                  {
                    userName ?
                      <p className="text-user-name">{userName}</p>
                      :
                      <p className="text-service">Departamento de Psicología</p>
                  }
                </Menu.Item>
              }
              {
                (patientLandingRoute && userName) &&
                <>
                  <Menu.Item key="1" style={{ padding: 0 }}>
                    <p className="text-user-name-patient">{userName}</p>
                  </Menu.Item>
                  <Menu.Item key="logout" onClick={handleLogout} className="logout-menu-item">
                    <span className="logout-link">Cerrar sesión</span>
                  </Menu.Item>
                </>
              }
            </Menu>
          }
        </Header>
      }
      <Content className={psychologyRoute && "psychology-component"}>
        <Row justify={`center ${withoutHeader ? '' : 'mt-80'}`}>
          <Col xl={24} lg={24} md={24}>
            {React.cloneElement(children, {
              refreshTimer,
              refreshTestName,
              refreshUserName,
              refreshInitialTimeStamp,
            })}
            <Outlet
              refreshTimer={refreshTimer}
              refreshTestName={refreshTestName}
              refreshUserName={refreshUserName}
              refreshInitialTimeStamp={refreshInitialTimeStamp}
            />
          </Col>
        </Row>
      </Content>
      <Modal
        title={<strong>¿Estás seguro que deseas cerrar sesión?</strong>}
        open={isLogoutModalVisible}
        onOk={handleLogoutConfirm}
        onCancel={() => setIsLogoutModalVisible(false)}
        okText="Sí, cerrar sesión"
        cancelText="Cancelar"
        okButtonProps={{ danger: true, className: 'cmt-button primary' }}
        cancelButtonProps={{ className: 'cmt-button secondary outline' }}
        centered
        width={450}
        wrapClassName="public-layout logout-modal-wrap"
      >
        <p className="mt-20 text-center">
          Si cierras sesión, se borrarán los datos del paciente actual.
        </p>
      </Modal>
    </Layout>
  );
};

export default PublicLayout;